/* eslint no-restricted-syntax: 0 */
/* eslint no-console: 0 */
import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
} from 'react'
import Loading from '../components/loading'

type IProps = {
  children: ReactNode;
}

type LoadingContextProps = {
  isLoading: boolean;
  onSetLoading(value: boolean): void;
}

const LoadingContext = createContext({} as LoadingContextProps)

const LoadingProvider = ({ children }: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  function onSetLoading(value: boolean): void {
    setIsLoading(value)
  }

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        onSetLoading,
      }}
    >
      {children}
      {
        isLoading && <Loading />
      }
    </LoadingContext.Provider>
  )
}

export const useLoading = () => {
  const context = useContext(LoadingContext)

  if (!context) {
    throw new Error('useLoading must be used within a provider LoadingProvider')
  }

  return context
}

export default LoadingProvider
